import * as Sentry from '@sentry/browser';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import { createRoot } from 'react-dom/client';
import RootContainer from './containers/RootContainer';

const isDevelopment = process.env.NODE_ENV === 'development';

mixpanel.init(
  process.env.MIXPANEL_PROJECT_TOKEN,
  {
    api_host: process.env.MIXPANEL_API_ENDPOINT,
  },
  '',
);

if (isDevelopment) mixpanel.disable();

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  enabled: process.env.NODE_ENV === 'production',
  release: process.env.RELEASE,
  denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i, /^safari-(web-)?extension:\/\//i],
  // Benign browser warning, not an actual error
  ignoreErrors: [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
    // Clerk token refresh hitting a client-side network failure (offline, ad blocker, sleeping laptop)
    /ClerkJS: Token refresh failed.*Failed to fetch/,
  ],
  // Axios errors have no first-party frames and no request info, so attach it to know which endpoint failed
  beforeSend(event, hint) {
    const error = hint?.originalException;
    if (!axios.isAxiosError(error)) return event;

    const method = error.config?.method?.toUpperCase();
    const url = error.config?.url;
    event.tags = { ...event.tags, 'http.method': method, 'http.url': url, 'http.status': error.response?.status };
    event.contexts = {
      ...event.contexts,
      axios: {
        method,
        url,
        baseURL: error.config?.baseURL,
        status: error.response?.status,
        data: error.response?.data,
      },
    };
    return event;
  },
});

const root = createRoot(document.getElementById('root'));

root.render(<RootContainer />);
